<template>
    <section>
        <div class="row mt-5">
            <div class="col-xl-4 col-lg-6 col-md-8 col-sm-10 col-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Ringkasan Data Siswa
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-5">
                        <div class="row mb-1 align-items-center">
                            <div class="col-sm-5 col-12 p-1">
                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                    Nama Lengkap
                                </label>
                            </div>
                            <div class="col-sm-7 col-12 px-1">
                                <h4 class="mb-0 font-weight-medium text-loading">
                                    {{ student.user.name }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-sm-5 col-12 p-1">
                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                    Skor GCA
                                </label>
                            </div>
                            <div class="col-sm-7 col-12 px-1">
                                <h4 class="mb-0 font-weight-medium text-loading" v-if="student.psychoScore">
                                    {{ student.psychoScore.categoryIQ }}
                                </h4>
                                <i class="fa fa-minus" v-else></i>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="n in 3">
                            <div class="col-sm-5 col-12 p-1">
                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                    Rekomendasi {{ n }}
                                </label>
                            </div>
                            <div class="col-sm-7 col-12 px-1">
                                <h4 class="mb-0 font-weight-medium text-loading" v-if="student.psychoScore">
                                    {{ student.psychoScore['recommendation' + n] }}
                                </h4>
                                <i class="fa fa-minus" v-else></i>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-sm-5 col-12 p-1">
                                <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                    File
                                </label>
                            </div>
                            <div class="col-sm-7 col-12 px-1">
                                <button v-b-tooltip.hover title="Download file psikotes siswa" v-on:click="download" type="button" class="btn btn-sm btn-link font-weight-medium p-0" v-if="student.psychoScore && student.psychoScore.fileScore">
                                    <file-icon v-bind:type="student.psychoScore.fileExtension" class="mr-1"></file-icon> Download
                                </button>
                                <i class="fa fa-minus" v-else></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import FileIcon from "@/components/item/FileIcon";
    import qs from 'qs';

    export default {
        name: "AccountStudentPsychoTest",
        components: {
            FileIcon
        },
        data() {
            return {
                student: {user: {}}
            };
        },
        methods: {
            download() {
                if (this.student.psychoScore) {
                    let token = localStorage.getItem("vue-authenticate.vueauth_token");
                    window.location = process.env.API_URL + '/psycho-score/download-file/' + this.student.psychoScore.id + '?' + qs.stringify({token: token}, {encode: false});
                }
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/student/profile').then(response => {
                this.student = response.data.data;
            });
            
            document.title = 'Laporan Psikotest - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    @media (max-width: 575.98px) {
        .form-divider::before{ display: none; }
    }
</style>


// WEBPACK FOOTER //
// src/components/account/student/PsychoTest.vue